<div class="!bg-[#F0F0F0]">
  <div class="p-4 !mb-[20px] bg-white">
    <div class="flex justify-between items-center border-b pb-2">
      <!-- <div>
        <label class="!text-[20px] !font-medium roboto text-[#21252A]"
          >RFI #1: RFI-001 - Clarification on Design Layout</label
        >
        <div class="flex space-x-4 mt-2">
          <button
            (click)="setActiveTab('General')"
            [class.border-b-orange-500]="activeTab === 'General'"
            [class.text-orange-600]="activeTab === 'General'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            General
          </button>
          <button
            (click)="setActiveTab('Related Items')"
            [class.border-b-orange-500]="activeTab === 'Related Items'"
            [class.text-orange-600]="activeTab === 'Related Items'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            Related Items (0)
          </button>
          <button
            (click)="setActiveTab('Emails')"
            [class.border-b-orange-500]="activeTab === 'Emails'"
            [class.text-orange-600]="activeTab === 'Emails'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            Emails (0)
          </button>
          <button
            (click)="setActiveTab('Change History')"
            [class.border-b-orange-500]="activeTab === 'Change History'"
            [class.text-orange-600]="activeTab === 'Change History'"
            class="text-gray-600 hover:text-orange-600 border-b-2 border-transparent pb-1"
          >
            Change History
          </button>
        </div>
      </div> -->
      <!-- <div class="flex space-x-2">
        <button
          class="border border-[#e76b3f] !h-[38px] text-[#e76b3f] px-3 pb-2 rounded"
        >
          Export <mat-icon class="pt-[8px]">expand_more</mat-icon>
        </button>
        <button
          class="border border-[#e76b3f] !h-[38px] text-[#e76b3f] px-4 pb-2 rounded"
        >
          Edit <mat-icon class="pt-[4px] !text-base">edit</mat-icon>
        </button>
        <button
          class="bg-[#e76b3f] text-white px-4 py-2 !h-[38px] rounded hover:bg-orange-600"
        >
          Close RFI
        </button>
      </div> -->
    </div>
  </div>
  <div class="mx-[20px]">
    <app-rfi-request></app-rfi-request>
  </div>
  <div class="mx-[20px] mt-[20px]">
    <app-rfi-response></app-rfi-response>
  </div>
  <div class="mx-[20px] mt-[20px]">
    <app-general-response></app-general-response>
  </div>
</div>
